import Styled, { css } from 'styled-components';

import { Caption } from '../../../Typography/Caption';
import { cssDeclaration } from '../../../_ThemeTwo_/Utils/Styles/cssDeclaration';

import { IVerTaskCard } from './common';
import { TaskBlurbStyles } from './TaskBlurbStyles';

export const VerTaskBlurb = Styled(Caption)<IVerTaskCard>`
  ${TaskBlurbStyles}

  ${({ theme: { taskCard, themeTwo }}) => taskCard.statusPill && css`
    /* font-size */
    ${taskCard.statusPill.font && taskCard.statusPill.font.size && cssDeclaration(themeTwo, 'font-size', taskCard.statusPill.font.size)};
  `}
`;
